module.exports = __webpack_public_path__ + "static/img/3hunan.b2fb0afd.jpg";